// extracted by mini-css-extract-plugin
export default {"titleMedium":"styles_titleMedium__yaz-L","titleRegular":"styles_titleRegular__KjLrY","titleBold":"styles_titleBold__LInhE","titleSemiBold":"styles_titleSemiBold__-2yWZ"};